<app-basic-page
  [pageTitle]="'Companies & Customers'"
  [pageDescription]="'Customers collected by Chrome Extension or manually created.'"
>
  <div class="vertical header-right">
    <button nz-button nzType="primary" nzSize="default" (click)="onNewBtnClick()">
      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
      Add Customer
    </button>
    <button nz-button nzType="default" nzSize="default" (click)="onGenerateBtnClick()">
      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
      Generate Customer
    </button>
  </div>

  <nz-tabset>
    <nz-tab nzTitle="Companies">
      <div class="tab-content vertical">
        <button class="right" nz-button nzType="primary" nzSize="default" (click)="onNewCompanyBtnClick()">
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
          Add Company
        </button>
        <nz-table class="full-width" #companyTable [nzData]="companyList()">
          <thead>
            <tr>
              <th [nzWidth]="'60px'"></th>
              <th>Title</th>
              <th [nzWidth]="'60px'" [nzAlign]="'center'">Customers</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (data of companyTable.data; track data) {
              <tr>
                <td [nzExpand]="expandSet.has(data.id)" (nzExpandChange)="onExpandChange(data.id, $event)"></td>
                <td>{{ data.title }}</td>
                <td [nzAlign]="'center'">
                  <button nz-button nzType="text" nzSize="small" (click)="onExpandClick(data.id)">
                    {{ getCustomerListByCompanyId(data.id)().length }}
                  </button>
                </td>
                <td>
                  <button nz-button nzType="default" nzSize="small" (click)="onEditCompanyClick(data)">
                    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
                    Edit
                  </button>
                </td>
              </tr>
              <tr [nzExpand]="expandSet.has(data.id)">
                <div class="card-grid">
                  @for (item of getCustomerListByCompanyId(data.id)(); track $index) {
                    <app-profile-card [resume]="item"></app-profile-card>
                  }
                </div>
              </tr>
            }

            @if (getCustomerListByCompanyId()().length > 0) {
              <tr>
                <td [nzExpand]="expandSet.has('')" (nzExpandChange)="onExpandChange('', $event)"></td>
                <td>Customers without company</td>
                <td [nzAlign]="'center'">
                  <button nz-button nzType="text" nzSize="small" (click)="onExpandClick('')">
                    {{ getCustomerListByCompanyId()().length }}
                  </button>
                </td>
                <td></td>
              </tr>
              <tr [nzExpand]="expandSet.has('')">
                <app-resume-list-table [resumeList]="getCustomerListByCompanyId()()"></app-resume-list-table>
              </tr>
            }
          </tbody>
        </nz-table>
      </div>
    </nz-tab>
    <nz-tab nzTitle="Real Customers">
      <div class="tab-content">
        <app-resume-list-table [resumeList]="realResumeList()"></app-resume-list-table>
      </div>
    </nz-tab>
    <nz-tab nzTitle="AI Customers">
      <div class="tab-content">
        <app-resume-list-table [resumeList]="aiResumeList()"></app-resume-list-table>
      </div>
    </nz-tab>
    <nz-tab nzTitle="Personality">
      <div class="card-grid tab-content">
        @for (item of personalityItemList(); track $index) {
          <app-personality-card [personality]="item"></app-personality-card>
        }
        <app-add-personality-card></app-add-personality-card>
      </div>
    </nz-tab>
  </nz-tabset>
</app-basic-page>

<app-edit-resume [resume]="newResume!" [isEdit]="false" [(isVisible)]="isNewEditVisible"></app-edit-resume>
<app-new-edit-company
  [selectedItem]="selectedCompany"
  [(isNewEditVisible)]="isNewEditCompanyVisible"
></app-new-edit-company>
<app-generate-resume-text-input [(isVisible)]="isGenerateVisible"></app-generate-resume-text-input>
